export default {
  lang:"en",
  setLang(lang){
    this.lang=lang
  }
}



// WEBPACK FOOTER //
// ./src/assets/global.js